import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
	ElementRef,
} from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import {
	CarrierDTOResponse,
	GET_CITY_STATE_FROM_LOCATION_STRING,
	HISTORICAL_LOADS_TABLE,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	LoadDTO,
	MercuryLoadDTO,
	MY_LOADS_TABLE,
	MyLoadsTable,
	RestService,
	TO_DOLLARS,
	IS_NOT_EMPTY,
} from 'cargo-chief-commons';
import { environment } from '@environment/environment';
import { Router } from '@angular/router';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { SelectionModel } from '@angular/cdk/collections';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';

@Component({
	selector: 'app-loads-table',
	templateUrl: './loads-table.component.html',
	styleUrls: ['./loads-table.component.scss'],
})
export class LoadsTableComponent implements OnInit {
	@Input() loadsList: Array<LoadDTO | MercuryLoadDTO> = null;
	@Input() numberOfLoads = null;
	@Input() pageSize: number = 20;
	@Input() page: number = 0;
	@Input() isHistorical: boolean = false;
	@Input() selectEnabled: boolean = false;
	@Input() showUserColumn: boolean = false;
	@Input() showPredictedPriceColumn: boolean = false;
	@Input() showCarrierColumn: boolean = false;
	@Input() showOffersColumn: boolean = false;
	@Input() showViewsColumn: boolean = false;
	@Input() isLoadingLoadsList: boolean = false;

	@Output() pageNumber: EventEmitter<any> = new EventEmitter();
	@Output() openCustomerUpdate: EventEmitter<any> = new EventEmitter();
	@Output() updatedSort: EventEmitter<any> = new EventEmitter();
	@Output() cellSelected: EventEmitter<{ columnName: string; data: any }> = new EventEmitter();

	@ViewChild('carrierColumnTableHeader')
	carrierColumnTableHeader: ElementRef<HTMLDivElement>;

	@ViewChild('equipmentColumnTableHeader')
	equipmentColumnTableHeader: ElementRef<HTMLDivElement>;

	LOAD_NUMBER_COLUMN = 'loadNumber';
	CARRIER_COLUMN = 'carrier';
	USER_COLUMN = 'user';
	PREDICTED_PRICE = 'predictedPrice';
	LOAD_STATUS = 'loadStatusText';
	OFFERS_COLUMN = 'offers';
	VIEWS_COLUMN = 'views';
	TO_DOLLARS = TO_DOLLARS;

	displayedColumns = [
		this.LOAD_NUMBER_COLUMN,
		'pickupDate',
		'deliveryDate',
		'origin',
		'destination',
		'trailerType',
		'allInCost',
		'priceToShipper',
		'bidCount',
		'loadStatusText',
	];
	dataSource = new MatTableDataSource<MyLoadsTable>([]);
	updatingLoad: boolean = false;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;

	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;
	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;
	selection = new SelectionModel<MyLoadsTable>(true, []);
	SELECT_COLUMN = 'select';

	sortField: string = 'created';
	sortOrder: string = 'desc';

	constructor(
		private router: Router,
		private changeDetectorRefs: ChangeDetectorRef,
		private urlService: UrlService,
		private restService: RestService,
		private utilService: UtilService,
		public accountSettings: AccountSettingsService
	) {}

	ngOnInit() {
		if (this.accountSettings.ROLE_BASED_CUSTOMER_DATA_ACCESS) {
			if (this.showCarrierColumn) {
				this.displayedColumns.splice(2, 0, 'customer');
			} else {
				const loadNumberIndex = this.displayedColumns.indexOf(this.LOAD_NUMBER_COLUMN) + 1;
				this.displayedColumns.splice(loadNumberIndex, 0, 'customer');
			}
		}
		this.initializePage();
	}

	initializePage() {
		this.dataSource.paginator = this.paginator;
	}

	initializeSort() {
		this.dataSource.sort = this.sort;
	}

	ngOnChanges() {
		if (this.selectEnabled) {
			if (this.displayedColumns.indexOf(this.SELECT_COLUMN) === -1) {
				this.displayedColumns.unshift(this.SELECT_COLUMN);
			}
		} else {
			this.displayedColumns = this.displayedColumns.filter(
				(header) => header !== this.SELECT_COLUMN
			);
		}

		if (this.showUserColumn) {
			if (this.displayedColumns.indexOf(this.USER_COLUMN) === -1) {
				this.displayedColumns.push(this.USER_COLUMN);
			}
		} else {
			this.displayedColumns = this.displayedColumns.filter((header) => header !== this.USER_COLUMN);
		}
		if (this.showPredictedPriceColumn) {
			this.updateDisplayedColums(this.showPredictedPriceColumn, this.PREDICTED_PRICE, 'bidCount');
			this.displayedColumns = this.displayedColumns.filter((header) => header !== this.LOAD_STATUS);
		} else {
			this.displayedColumns = this.displayedColumns.filter(
				(header) => header !== this.PREDICTED_PRICE
			);
			this.updateDisplayedColums(!this.showPredictedPriceColumn, this.LOAD_STATUS, 'bidCount');
		}
		this.updateDisplayedColums(
			this.showCarrierColumn,
			this.CARRIER_COLUMN,
			this.LOAD_NUMBER_COLUMN
		);
		this.updateDisplayedColums(this.showOffersColumn, this.OFFERS_COLUMN, 'priceToShipper');
		this.updateDisplayedColums(this.showViewsColumn, this.VIEWS_COLUMN, this.OFFERS_COLUMN);

		this.buildView();
	}

	buildView() {
		if (IS_NOT_NULL_OR_UNDEFINED(this.loadsList) && this.loadsList.length > 0) {
			if (this.isHistorical) {
				this.dataSource = new MatTableDataSource<MyLoadsTable>(
					HISTORICAL_LOADS_TABLE(<MercuryLoadDTO[]>this.loadsList)
				);
			} else {
				this.dataSource = new MatTableDataSource<MyLoadsTable>(
					MY_LOADS_TABLE(<LoadDTO[]>this.loadsList)
				);
			}
			this.changeDetectorRefs.detectChanges();
		} else {
			this.dataSource = new MatTableDataSource<MyLoadsTable>([]);
		}
		if (IS_NOT_NULL_OR_UNDEFINED(this.page) && IS_NOT_NULL_OR_UNDEFINED(this.paginator)) {
			this.paginator.pageIndex = this.page;
		}
	}

	storeLoadUrl(row: MyLoadsTable) {
		if (!this.isHistorical) {
			if (IS_NOT_NULL_OR_UNDEFINED(row.quoteId)) {
				localStorage.setItem('loadURL', row.url);
				this.router.navigate(['users/quotedetails', row.quoteId]);
			}
			if (IS_NOT_NULL_OR_UNDEFINED(row.loadId) && IS_NULL_OR_UNDEFINED(row.quoteId)) {
				localStorage.setItem('loadURL', row.url);
				this.router.navigate(['users/load_details', row.loadId]);
			}
		}
	}

	getLoads() {
		this.pageNumber.emit(this.paginator?.pageIndex || 0);
	}

	carrierSelected(selectedCarrier: CarrierDTOResponse, row: MyLoadsTable, index: number) {
		if (this.utilService.isNullOrUndefined(selectedCarrier)) {
			return;
		}
		this.updatingLoad = true;
		const url = this.urlService.updateMercuryLoad(row.loadId);
		const payload = {
			carrierId: selectedCarrier.id,
		};
		this.restService.PUT(url, payload).subscribe(
			() => {
				const loadsListCopy = [...this.loadsList];
				loadsListCopy[index].carrier = {
					...loadsListCopy[index].carrier,
					businessName: selectedCarrier.businessName,
					doingBusinessAs: selectedCarrier.doingBusinessAs,
					id: selectedCarrier.id,
				};
				this.loadsList = [...loadsListCopy];
				this.buildView();
				this.utilService.showSnackbar('Carrier assigned', SNACKBAR.SUCCESS, SNACKBAR.ACTION);
				this.updatingLoad = false;
			},
			(error) => {
				this.updatingLoad = false;
				this.utilService.showSnackbar('Unable to assign carrier.', SNACKBAR.ERROR, SNACKBAR.ACTION);
			}
		);
	}

	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.dataSource.data.length;
		return numSelected == numRows;
	}

	masterToggle() {
		this.isAllSelected()
			? this.selection.clear()
			: this.dataSource.data.forEach((row) => this.selection.select(row));
	}

	updateCustomer(load: MyLoadsTable) {
		this.selection.clear();
		this.selection.select(load);
		setTimeout(() => {
			this.openCustomerUpdate.emit();
		});
	}

	sortData(event) {
		if (event) {
			this.sortField = event.active;
			this.sortOrder = event.direction;
			this.updatedSort.emit({ sortField: this.sortField, sortOrder: this.sortOrder });
			if (this.paginator) {
				this.paginator.pageIndex = 0;
			}
			this.getLoads();
		}
	}

	selectCell({ columnName, data }: { columnName: string; data: MyLoadsTable }) {
		if (!this.isHistorical) {
			return;
		}
		switch (columnName) {
			case 'carrier':
				this.cellSelected.emit({
					columnName,
					data: {
						id: data.carrierId,
						businessName: data.carrierName,
					},
				});
				break;
			case 'origin':
				const origin = GET_CITY_STATE_FROM_LOCATION_STRING(data.origin);
				this.cellSelected.emit({
					columnName,
					data: {
						city: origin.city,
						state: origin.state,
					},
				});
				break;
			case 'destination':
				const destination = GET_CITY_STATE_FROM_LOCATION_STRING(data.destination);
				this.cellSelected.emit({
					columnName,
					data: {
						city: destination.city,
						state: destination.state,
					},
				});
				break;
		}
	}

	updateDisplayedColums(isColumnEnabled: boolean, columnNameToAdd: string, addAfterColumn: string) {
		if (isColumnEnabled) {
			if (this.displayedColumns.indexOf(columnNameToAdd) === -1) {
				const previousColumnIndex = this.displayedColumns.indexOf(addAfterColumn) + 1;
				this.displayedColumns.splice(previousColumnIndex, 0, columnNameToAdd);
			}
		} else {
			this.displayedColumns = this.displayedColumns.filter((header) => header !== columnNameToAdd);
		}
	}

	getTrailerType(trailerType: any): string {
		if (Array.isArray(trailerType)) {
			trailerType = trailerType.map((trailer) => trailer.name).join(',');
		}
		if (IS_NOT_EMPTY(trailerType)) {
			return trailerType?.replace(/,/g, ', ');
		}
		return '';
	}

	clearSort() {
		if (this.sort) {
			this.sort.active = '';
			this.sort.direction = '';
		}
	}
}
